__turbopack_context__.v({
  "body": "index-module__uqudzq__body",
  "checkbox-icon": "index-module__uqudzq__checkbox-icon",
  "inner": "index-module__uqudzq__inner",
  "input": "index-module__uqudzq__input",
  "label": "index-module__uqudzq__label",
  "root": "index-module__uqudzq__root",
  "tooltipIconWrapper": "index-module__uqudzq__tooltipIconWrapper",
});
